<a [href]="app_link" target="_blank" class="{{'install-eatclub install-eatclub_' + type}}" >
	Install EatClub
</a>